import React from 'react';
import Link from '../Link';
import Tag from '../Tag/Tag';
import ImageWrapper from '../Image/ImageWrapper';
import podcastArrow from '../../Icons/podcast-arrow.svg';
import { isArray, pathToModel, basePathTag } from '../../../utils';

import './index.scss';

const CardUpdate = ({ post, variant = 'default' }) => {
  const {
    slug,
    date,
    model: { apiKey },
    title,
    tags,
    image,
    isPodcast = apiKey === 'podcast' ?? true,
  } = post;

  const postUrl = pathToModel(apiKey, slug);
  const basePath = basePathTag(apiKey);

  return (
    <Link to={postUrl} className={`card-update ${isPodcast ? 'podcast' : ''} ${variant ? variant : ''}`}>
      <div className="image">
        {isArray(tags) && (
          <div className="tags">
            {tags.map((tag, index) => (
              <Tag key={index} basePath={basePath} title={tag.title} slug={tag.slug} variant={tag.color} />
            ))}
          </div>
        )}

        {image?.url ? (
          <div className="image-wrapper v2">
            <img src={image.url} alt={image.alt} loading="lazy" />
          </div>
        ) : (
          <ImageWrapper image={image} />
        )}
      </div>
      <div className="information">
        <div className="meta">
          {date && <span>{date}</span>}

          {isPodcast && (
            <span className="podcast-tag">
              <img src={podcastArrow} alt="Podcast arrow" />
              Podcast
            </span>
          )}
        </div>

        <div>
          {isPodcast && isArray(tags) && (
            <div className="tags">
              {tags.map((tag, index) => (
                <Tag key={index} basePath={basePath} title={tag.title} slug={tag.slug} variant={tag.color} />
              ))}
            </div>
          )}
          <h3>{title}</h3>
        </div>
      </div>
    </Link>
  );
};

export default CardUpdate;
